import script from "./indexEdm.vue?vue&type=script&setup=true&lang=js"
export * from "./indexEdm.vue?vue&type=script&setup=true&lang=js"

import "./indexEdm.vue?vue&type=style&index=0&id=e0505a04&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0505a04"]])

export default __exports__